import { TeGrid } from '@topcon/tuicl-react';
import styled from 'styled-components';

const CustomGrid = styled(TeGrid)`
  grid-template-columns: ${(props) =>
    `repeat(${props.columns ?? 1}, minmax(auto, 1fr)) !important`};
`;

export default CustomGrid;
